import React from 'react'

export default function Footer(){
    
    return (
        // <section className="main-content">
            <footer className="footer">
                <span>Copyright © 2025 เพื่อนรับเหมา.com</span>
            </footer>
        // </section>
    )
}

